import { Form, DatePicker } from "antd";
import { Controller } from "react-hook-form";
import {
  CalendarIcon,
  DoubleArrow,
  InfoIconOutlined,
  SelectArrow,
} from "../../CustomIcons";

// export interface InputFieldProps<T extends FieldValues> {
//   fieldName: Path<T>;
//   isRequired?: boolean;
//   label?: string;
//   validate?: "" | "success" | "warning" | "error" | "validating" | undefined;
//   validMessage?: string | React.ReactNode;
//   className?: string;
//   control: Control<T>;
//   defaultValue?: PathValue<T, Path<T>> | undefined;
//   rules?: object;
//   iProps?: React.InputHTMLAttributes<HTMLInputElement>;
//   prefix?: React.ReactNode;
//   disabled?: boolean;
//   tooltipTitle?: string | React.ReactNode;
//   optionalLabel?: string;
//   hintMessage?: string;
// }

export const DateField = ({
  fieldName,
  isRequired,
  label,
  validate,
  validMessage,
  className,
  control,
  defaultValue,
  rules,
  iProps,
  prefix,
  disabled,
  tooltipTitle,
  optionalLabel,
  hintMessage,
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any
any) => {
  return (
    <Form.Item
      required={isRequired ?? false}
      label={<div className="label_text">{label}</div>}
      validateStatus={validate}
      help={validMessage}
      className={className}
      tooltip={
        tooltipTitle && {
          title: tooltipTitle,
          placement: "topLeft",
          arrow: false,
          icon: <InfoIconOutlined />,
        }
      }
    >
      <Controller
        name={fieldName}
        control={control}
        defaultValue={defaultValue ?? ""}
        rules={rules}
        render={({ field: { onChange, value } }) => (
          <>
            <DatePicker
              disabled={disabled && disabled}
              value={value}
              className="formControl"
              prefix={prefix}
              suffixIcon={<CalendarIcon />}
              placeholder="MM, DD, YYYY"
              superNextIcon={<DoubleArrow />}
              superPrevIcon={<DoubleArrow />}
              prevIcon={<SelectArrow />}
              nextIcon={<SelectArrow />}
              autoComplete="new-state"
              onChange={(e) => {
                onChange(e);
              }}
              format={[
                "MMM D, YYYY",
                "MM/DD/YYYY",
                "MM-DD-YYYY",
                "MMDDYYYY",
                "DDMMYYYY",
                "DD/MM/YYYY",
                "DD-MM-YYYY",
                "MMM D YYYY",
                "M-D-YYYY",
                "M/D/YYYY",
                "D-M-YYYY",
                "D/M/YYYY",
                "MDYYYY",
                "DMYYYY",
              ]}
              {...iProps}
            />
            {optionalLabel && (
              <div className="optional-label">{optionalLabel}</div>
            )}
            {hintMessage && <div className="hint-label">{hintMessage}</div>}
          </>
        )}
      />
    </Form.Item>
  );
};

export default DateField;
